var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9199 0C6.39492 0 1.91992 4.475 1.91992 10C1.91992 15.525 6.39492 20 11.9199 20C17.4449 20 21.9199 15.525 21.9199 10C21.9199 4.475 17.4449 0 11.9199 0ZM11.9199 3C13.5749 3 14.9199 4.345 14.9199 6C14.9199 7.66 13.5749 9 11.9199 9C10.2649 9 8.91992 7.66 8.91992 6C8.91992 4.345 10.2649 3 11.9199 3ZM11.9199 17.2C9.41492 17.2 7.21492 15.92 5.91992 13.98C5.94492 11.995 9.92492 10.9 11.9199 10.9C13.9149 10.9 17.8899 11.995 17.9199 13.98C16.6249 15.92 14.4249 17.2 11.9199 17.2Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(1.91992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9ef11659add06d48f8d7b6c69f8e4e70.svg";
export { ForwardRef as ReactComponent };